import React from 'react';
import WeatherIcon from 'components/other/WeatherIcon'; // Assuming WeatherIcon is a custom component
import GasConsumptionGraph from 'components/other/GasConsumptionGraph';
import Navigation from 'components/other/Navigation'; // Assuming Navigation is a custom component
import HourlyTrendsPage from 'components/other/HourlyTrendsPage';
import { useNavigate, useParams } from 'react-router-dom';
import { TrendsType } from 'types';

export function TrendsScreen() {
  const navigate = useNavigate();
  const type = useParams().type as TrendsType;
  const now = new Date();

  if (!type) return <></>;

  return (
    <div className="screen new-screen overflow-hidden bg-background">
      <div className="flex w-full justify-center">
        <div className="flex w-[90%] flex-col">
          {/* Weather and Tabs */}
          <div className="container mx-auto flex items-end justify-between space-x-2 bg-light-blue-500 px-20 pt-4">
            <div className="flex space-x-4">
              <button
                className={`rounded-t-lg px-4 py-2 text-white ${
                  type === TrendsType.Hourly
                    ? 'bg-background'
                    : 'bg-light-blue-500'
                }`}
                onClick={() => navigate(`/trends/hour`)}
              >
                Hourly Trends
              </button>
              <button
                className={`rounded-t-lg px-4 py-2 text-white ${
                  type !== TrendsType.Hourly
                    ? 'bg-background'
                    : 'bg-light-blue-500'
                }`}
                onClick={() => navigate(`/trends/day`)}
              >
                Daily Totals
              </button>
            </div>

            <div className="flex items-center space-x-2">
              <WeatherIcon /> {/* Custom component for weather icons */}
            </div>
          </div>

          {/* Content based on active tab */}
          <div className="container mx-auto flex grow flex-col px-4 py-4 text-white">
            {type === TrendsType.Hourly ? (
              <HourlyTrendsPage startTime={now} />
            ) : (
              <GasConsumptionGraph startTime={now} view={type} />
            )}
          </div>

          <Navigation />
        </div>
      </div>
    </div>
  );
}
